module.exports = __webpack_public_path__ + "img/big_1_1.3c460e5c.png";